
import { mapGetters } from 'vuex'
import permissions from '~/assets/js/enums/ModeratorPermissions'

export default {
  name: 'ProfileDropDown',
  props: {
    onLogout: {
      type: Function,
      default: () => null
    },
    dropdownPosition: {
      type: String,
      default: 'right'
    },
    alignCenter: Boolean
  },
  data () {
    return {
      userMenu: false,
      showModeratorList: false
    }
  },
  computed: {
    ...mapGetters({
      activeSidebar: 'sidebar/activeSidebar'
    }),
    navIsActive () {
      return ['my-subscription', 'account-settings'].some(substring => this.$route.name.includes(substring))
    },
    avatarUrl () {
      return this.$auth.user.acting_user ? this.$auth.user.acting_user.avatar_url : this.$auth.user.avatar_url
    }
  },
  watch: {
    $route () {
      this.userMenu = false
    }
  },
  methods: {
    actAsUser (userId) {
      this.$axios.post('v1/users/acting-as/', {
        user_id: userId
      })
        .then((res) => {
          const permission = res.data.permissions

          if (permission & permissions.ALERTS) {
            window.location = this.$router.resolve({ name: 'dashboard-alerts-configure' }).href

            return
          }

          if (permission & permissions.CHATBOT) {
            window.location = this.$router.resolve({ name: 'dashboard-chatbot-commands' }).href

            return
          }

          if (permission & permissions.STATISTICS) {
            window.location = this.$router.resolve({ name: 'dashboard-statistics' }).href

            return
          }

          if (permission & permissions.LINKSPREE) {
            window.location = this.$router.resolve({ name: 'dashboard-tools-linkspree' }).href
          }
        })
    },
    openAccountSidebar () {
      this.userMenu = false

      if (this.activeSidebar) {
        this.$store.commit('sidebar/setActiveSidebar', null)
        this.$store.commit('sidebar/setIsOpen', false)
        setTimeout(() => {
          this.$store.commit('sidebar/setActiveSidebar', 'account')
        }, 500)
      } else {
        this.$store.commit('sidebar/setActiveSidebar', 'account')
      }
    },
    logout () {
      this.$store.dispatch('logout', this.onLogout)
    }
  }
}
